import * as React from 'react';
import { getIsWhiteLabel } from '../../redux/modules/whiteLabel';
import { useAppSelector } from '@/redux/hooks';
import isEqual from 'react-fast-compare';
import LACrown from './LACrown/LACrown';
import WhiteLabelCrown from './WhiteLabelCrown/WhiteLabelCrown';

const Crown = () => {
    const whiteLabel = useAppSelector(getIsWhiteLabel, isEqual);
    return whiteLabel ? <WhiteLabelCrown /> : <LACrown />;
};

// because whitelabel will never update we can keep memo
export default React.memo(Crown);
